import { Skeleton } from 'corso-admin-ui';
import { ComponentProps } from 'react';
import { ShipmentTracking } from '~/components/tracking/ShipmentTracking';
import Paginator from '~/components/ui/Paginator';
import { useIsCorsoCxAgent } from '~/hooks/useIsCorsoAdmin';
import { useOrderTrackingQuery } from '~/hooks/useOrderTrackingQuery';
import { usePaginate } from '~/hooks/usePaginate';

/** Tracking for every parcel on an order. Corso admins only, since it hits the carrier. */
export function OrderTracking({
  storeOrderId,
  emptyMessage,
  renderLineItems,
}: {
  storeOrderId: number | undefined;
  emptyMessage: string;
  renderLineItems?: ComponentProps<typeof ShipmentTracking>['renderLineItems'];
}) {
  const isCorsoCx = useIsCorsoCxAgent();
  const { data: shipments = [], isLoading } =
    useOrderTrackingQuery(storeOrderId);
  const pagination = usePaginate({ items: shipments, perPage: 1 });

  if (!isCorsoCx || !storeOrderId) return null;

  const [shipment] = pagination.pageItems;
  const paginator = <Paginator pagination={pagination} />;

  return (
    <div className="flex flex-col gap-1">
      {isLoading && <Skeleton.TextBlock lines={3} />}

      {!isLoading && !shipment && (
        <p className="text-xs text-neutral-500">{emptyMessage}</p>
      )}

      {shipment && (
        <ShipmentTracking
          shipment={shipment}
          renderLineItems={renderLineItems}
          paginator={paginator}
        />
      )}

      {paginator}
    </div>
  );
}
